import {Component, Inject, OnDestroy, OnInit} from "@angular/core";
import RegroupementPlatDTO from "../../../../core/dtos/conditionnement/regroupement-plat-d-t-o";
import {
  RegroupementPlatService
} from "../../../../core/services/conditionnements/regroupement/regroupement-plat.service";
import {Auth2Service} from "../../../../core/services/security/auth2.service";
import {Subscription} from "rxjs";
import {UtilsService} from "../../../../core/utils/utils.service";
import PointDeLivraisonRegroupementPlatDTO
  from "../../../../core/dtos/conditionnement/point-de-livraison-regroupement-plat-dto";
import {MSG_KEY, MSG_SEVERITY} from "../../../../core/constants";
import {ToastService} from "../../../../core/services/technique/toast.service";
import {confirm} from "devextreme/ui/dialog";
import {ButtonThemeEnum} from "../../../../shared/ui/button/button-theme-enum";

@Component({
    selector: 'yo-regroupement-plat-dialog-plc',
    templateUrl: './regroupement-plat-dialog-plc.component.html',
    styleUrls: ['./regroupement-plat-dialog-plc.component.scss'],
    standalone: false
})

export class RegroupementPlatDialogPlcComponent implements OnInit, OnDestroy {
  selectedRows: number[] = [];
  selectedPrestationsByRows: Map<number, number[]> = new Map();
  plcList: PointDeLivraisonRegroupementPlatDTO[] = [];
  private subAddPlc: Subscription;
  private subAllPlc: Subscription;
  private subSave: Subscription;

  constructor(@Inject('dynamicData') public regroupementPlat: RegroupementPlatDTO,
              private regroupementSvc: RegroupementPlatService,
              private toastSvc: ToastService,
              private utilSvc: UtilsService,
              private authSvc: Auth2Service) {
  }

  ngOnInit() {
    this.initPlcList();
    this.initSubAddPlc();
  }

  ngOnDestroy() {
    this.utilSvc.unsubscribe(this.subAddPlc);
    this.utilSvc.unsubscribe(this.subAllPlc);
    this.utilSvc.unsubscribe(this.subSave);
  }

  openDialogAjoutPlc() {
    this.regroupementSvc.announceOpenAjoutPlc(this.regroupementPlat);
  }

  canEdit() {
    return this.authSvc.isSiteLocal(this.regroupementPlat.site.id)
  }

  async deleteValues() {
    const result = confirm(`Êtes vous sûr de vouloir supprimer les points de livraisons sélectionnés  ?`, 'Suppression des points de livraison');
    const isDeleted: boolean = await result;
    if (isDeleted) {
      this.regroupementSvc.deletePlc(this.selectedRows, this.regroupementPlat.id).subscribe({
        next: () => {
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Suppresion des points de livraison réalisée avec succès`);
          this.plcList = this.plcList.filter(plc => !this.selectedRows.includes(plc.id))
        }
      })
    }
  }

  updatePrestaList($event: any, plc: PointDeLivraisonRegroupementPlatDTO) {
    if ($event.value.length != plc.prestations.length) {
      plc.prestations = plc.availablePrestations.filter(p => $event.value.includes(p.id));
      this.selectedPrestationsByRows.set(plc.id, plc.prestations.map(presta => presta.id));
      this.updateRegroupementPlat(plc);
    }
  }

  private updateRegroupementPlat(plc: PointDeLivraisonRegroupementPlatDTO) {
    const idPrestas = plc.prestations.map(p => p.id)
    this.regroupementSvc.savePlcPrestations(plc.id, idPrestas , this.regroupementPlat.id).subscribe((res) => {
      if (res.one) {
        if (res.one.updateErreur) {
          this.regroupementSvc.announceErreurParametrage(res.one.erreurs)
        } else {
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Point de livraison ajouté avec succès`);
        }
      }
    })
  }

  private initSubAddPlc() {
    this.subAddPlc = this.regroupementSvc.subjectRegroupementAddPlc$.subscribe(() => {
      this.initPlcList();
    })
  }

  private initPlcList() {
    this.subAllPlc = this.regroupementSvc.getPlcList(this.regroupementPlat.id).subscribe((res) => {
      if (res) {
        let newSelectedList: Map<number, number[]> = new Map();
        res.resultList.forEach(line => {
          newSelectedList.set(line.id, line.prestations.map(prestation => prestation.id));
        })
        this.plcList = res.resultList;
        this.selectedPrestationsByRows = newSelectedList;
      }
    })
  }

  public readonly ButtonThemeEnum = ButtonThemeEnum;
}
